// extracted by mini-css-extract-plugin
export default {"tip":"Tip__tip__o5Hrk","content":"Tip__content__ywfjP","dismiss-button":"Tip__dismiss-button__kt5sA","dismissButton":"Tip__dismiss-button__kt5sA","toast":"Tip__toast__usqEp"};